import { Component, LoaderManager } from 'shimmer'

import {
  DirectionalLight,
  AmbientLight,
  Mesh,
  PlaneGeometry,
  MeshBasicMaterial
} from 'three'

import { webGL } from '@/webGL/WebGL'
import { textureLib } from '@/webGL/TextureLib'
import { MeshReflectorMaterial } from '@/webGL/materials/MeshReflectorMaterial'
import { Floor } from '@/webGL/objects/Floor2'
import { Screen } from '@/webGL/objects/Screen'

export class Environment extends Component {
  constructor (name, isPBR = false, x) {
    super()

    this.name = name
    this.isPBR = isPBR

    this.promise = this.load(name)
    this.animationClip = null

    this.setupLight()
    this.addScreen('/videos/test.mp4', -15)
    this.addScreen('/videos/test-2.mp4', 15)
  }

  async load (name) {
    if (this.isPBR) {
      await textureLib.promise
    }

    return LoaderManager.load(name, false, obj => {
      obj.material.envMap = textureLib.envMap
      obj.material.needsUpdate = true

      if (obj.name.startsWith('BLOOM_')) {
        obj.layers.enable(1)
        obj.traverse(child => child.layers.enable(1))
      }
    }).then(res => {
      this.object = res[0].object
      this.add(this.object)
      this.setupReflectors()
    })
  }

  addScreen (url, x) {
    const mesh = new Mesh(new PlaneGeometry(20, 10), new MeshBasicMaterial())
    mesh.position.y = 6
    mesh.position.z = -8
    mesh.position.x = x
    mesh.lookAt(0, mesh.position.y, 0)
    this.screen = new Screen(url, mesh)
    this.add(this.screen)
  }

  setupReflectors () {
    this.floor = new Floor()
    this.add(this.floor)
    // this.floor = this.getObjectByName('SM_SOL')
    // this.floor.material = new MeshReflectorMaterial(webGL.renderer.renderer, webGL.camera, webGL.scene, this.floor, {
    //   resolution: 1024,
    //   blur: [512, 128],
    //   mixBlur: 2.5,
    //   mixContrast: 1,
    //   mirror: 1
    // })
    // this.floor.material
  }

  // onUpdate () {
  //   if (this.floor) {
  //     this.floor.material.update()
  //   }
  // }

  setupLight () {
    if (!this.isPBR) { return }

    this.ambient = new AmbientLight(0xffffff, .3)
    this.add(this.ambient)

    this.directional = new DirectionalLight(0xffffff, 1)
    this.directional.position.set(-15, 15, 20)
    this.directional.lookAt(0, 0, 0)
    this.directional.castShadow = true
    this.directional.shadow.bias = -0.0004
    this.directional.shadow.camera.far = 70
    this.directional.shadow.camera.near = 0.001
    this.directional.shadow.mapSize.width = 1024
    this.directional.shadow.mapSize.height = 1024
    this.directional.shadow.camera.updateProjectionMatrix()
    this.add(this.directional)
  }
}